import React, { useState } from 'react';
import { StyledTextField } from '../productInformation';
import { useTranslation } from 'react-i18next';
import HelpIcon from '@mui/icons-material/Help';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';

interface FormAssumptionsProps {
  values: {
    production_process_description: string;
    assumptions_description: string;
    reference_service_life: string;
    cutoff_rules: string;
    additional_information: string;
  };
  setValues: Function;
}
export default function FormAssumptions({
  setValues,
  values,
}: FormAssumptionsProps) {
  const { t } = useTranslation('lca', { keyPrefix: 'assumptions' });
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    name: string
  ) => {
    setValues({
      ...values,
      [name]: e.target.value,
    });
  };

  const [popupOpen, setPopupOpen] = useState<boolean>(false);

  return (
    <div
      style={{
        display: 'flex',
        gap: '24px',
        flexDirection: 'column',
      }}
    >
      <Dialog
        open={popupOpen}
        onClose={() => setPopupOpen(false)}
        maxWidth="lg"
      >
        <DialogTitle>
          <Typography variant="h3">
            {t('referenceServiceLifeDialog.title')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography mb="16px">
            {t('referenceServiceLifeDialog.desc')}
          </Typography>
          <Typography variant="h4" mb="16px">
            {t('referenceServiceLifeDialog.whatIsIt')}
          </Typography>
          <Typography
            dangerouslySetInnerHTML={{
              __html: t('referenceServiceLifeDialog.whatIsItDesc'),
            }}
            mb="16px"
          />
          <Typography variant="h4" mb="16px">
            {t('referenceServiceLifeDialog.purpose')}
          </Typography>
          <Typography
            dangerouslySetInnerHTML={{
              __html: t('referenceServiceLifeDialog.purposeDesc'),
            }}
          />
          <Typography variant="h4" mb="16px">
            {t('referenceServiceLifeDialog.cutoffCriteria')}
          </Typography>
          <Typography
            dangerouslySetInnerHTML={{
              __html: t('referenceServiceLifeDialog.cutoffCriteriaDesc'),
            }}
          />
        </DialogContent>
      </Dialog>
      <StyledTextField
        fullWidth
        label={t('describeProcess')}
        name="production_process_description"
        value={values.production_process_description}
        onChange={(e) => handleChange(e, 'production_process_description')}
        multiline
        rows={4}
      />
      <StyledTextField
        fullWidth
        label={t('describeAssumptions')}
        name="assumptions_description"
        value={values.assumptions_description}
        onChange={(e) => handleChange(e, 'assumptions_description')}
        multiline
        rows={4}
      />
      <StyledTextField
        fullWidth
        label={t('referenceServiceLife')}
        name="reference_service_life"
        value={values.reference_service_life}
        onChange={(e) => handleChange(e, 'reference_service_life')}
        InputProps={{
          endAdornment: (
            <IconButton onClick={() => setPopupOpen(true)}>
              <HelpIcon />
            </IconButton>
          ),
        }}
      />
      <StyledTextField
        fullWidth
        label={t('cutoffRules')}
        name="cutoff_rules"
        value={values.cutoff_rules}
        onChange={(e) => handleChange(e, 'cutoff_rules')}
        multiline
        rows={4}
      />
      <StyledTextField
        fullWidth
        label={t('optionalAdditionalInformation')}
        name="additional_information"
        value={values.additional_information}
        onChange={(e) => handleChange(e, 'additional_information')}
        multiline
        rows={4}
      />
    </div>
  );
}
